export default {
  getData(state) {
    return state.data;
  },
  getTotal(state) {
    return state.total;
  },
  getCalculatedDeliveryPrice(state) {
    return state.calculatedDeliveryPrice;
  },
  getDetail(state) {
    return state.detail;
  },

};
